module.exports = __webpack_public_path__ + "6b07334d32946a3f06df36d24c28e801.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NonAuthHomePage/components/Description/images/mob3_2x.png
// module id = Cosl
// module chunks = 13